import { render, staticRenderFns } from "./VendorInfoUpdateReminderModal.vue?vue&type=template&id=72864232&scoped=true&lang=pug"
import script from "./VendorInfoUpdateReminderModal.vue?vue&type=script&lang=js"
export * from "./VendorInfoUpdateReminderModal.vue?vue&type=script&lang=js"
import style0 from "./VendorInfoUpdateReminderModal.vue?vue&type=style&index=0&id=72864232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72864232",
  null
  
)

export default component.exports